const CURRENT_USER_WINDOW_IDENTIFIER = Object.freeze({
    USER_PROFILE_MODULE_WINDOW_ID: 'profile',
});

export { CURRENT_USER_WINDOW_IDENTIFIER };

export default {
    CURRENT_USER_GROUP_WRAPPER: {
        hidden: true,
        type: 'group',
        id: 'currentUser',
        children: [],
        icon: '$wUser'
    },
    CHILDREN: {
        USER_PROFILE_MODULE: {
            type: 'module',
            id: 'profile',
            windowIdentifierType: CURRENT_USER_WINDOW_IDENTIFIER.USER_PROFILE_MODULE_WINDOW_ID,
            routerLink: '/user-profile',
        },
    }
}
